<div class="panel-shell">
  <header class="panel-header primary">
    <div class="panel-title text-bold flex-row-start-center">
      <mat-icon class="s-24 mr-8">{{ getIcon("EMAIL_HISTORY") }}</mat-icon>
      {{ "SENT_EMAILS.DETAIL_TITLE" | translate }}
    </div>
    <button
      mat-icon-button
      type="button"
      class="panel-close-btn"
      (click)="close()"
      [attr.aria-label]="'SENT_EMAILS.CLOSE' | translate"
    >
      <mat-icon>{{ getIcon("CLOSE") }}</mat-icon>
    </button>
  </header>

  <div class="panel-body">
    <!-- ERROR / NOT FOUND -->
    <div *ngIf="errorState" class="sed-state" role="alert">
      <mat-icon class="s-40 sed-state-icon">{{ getIcon("WARNING") }}</mat-icon>
      <div class="sed-state-title">
        {{
          (errorState === "not_found"
            ? "SENT_EMAILS.DETAIL.NOT_FOUND_TITLE"
            : "SENT_EMAILS.DETAIL.ERROR_TITLE"
          ) | translate
        }}
      </div>
      <div class="sed-state-text">
        {{
          (errorState === "not_found"
            ? "SENT_EMAILS.DETAIL.NOT_FOUND"
            : "SENT_EMAILS.DETAIL.ERROR_MESSAGE"
          ) | translate
        }}
      </div>
      <button
        *ngIf="errorState !== 'not_found'"
        mat-raised-button
        type="button"
        color="accent"
        class="mt-12"
        (click)="loadDetail()"
      >
        {{ "SENT_EMAILS.RETRY" | translate }}
      </button>
    </div>
    <!-- / ERROR -->

    <!-- LOADING WITHOUT ANY SUMMARY -->
    <div *ngIf="loading && !email" class="sed-state">
      <mat-spinner [diameter]="32"></mat-spinner>
      <div class="sed-state-text mt-8">
        {{ "SENT_EMAILS.DETAIL.LOADING" | translate }}
      </div>
    </div>

    <ng-container *ngIf="email && !errorState">
      <!-- HEAD: subject, status, dates -->
      <section class="sed-head">
        <div class="sed-subject">
          {{ email.subject || ("SENT_EMAILS.NO_SUBJECT" | translate) }}
        </div>
        <div class="sed-head-line">
          <app-sent-email-status
            [status]="email.status"
            [label]="email.status_label"
            [problem]="email.is_problem"
          ></app-sent-email-status>
          <span class="sed-muted">{{ email.mail_type_label }}</span>
          <span class="sed-muted sed-counter">
            <mat-icon class="s-16">{{ getIcon("VISIBLILITY") }}</mat-icon>
            {{ email.opens || 0 }} {{ "SENT_EMAILS.OPENS" | translate }}
          </span>
          <span class="sed-muted sed-counter">
            {{ email.clicks || 0 }} {{ "SENT_EMAILS.CLICKS" | translate }}
          </span>
        </div>

        <dl class="sed-fields">
          <ng-container *ngIf="email.sent_at || email.created_at">
            <dt>
              {{
                (email.sent_at
                  ? "SENT_EMAILS.DETAIL.SENT_AT"
                  : "SENT_EMAILS.DETAIL.CREATED_AT"
                ) | translate
              }}
            </dt>
            <dd>{{ email.sent_at || email.created_at | date: dateFormat }}</dd>
          </ng-container>
          <ng-container *ngIf="email.delivered_at">
            <dt>{{ "SENT_EMAILS.DETAIL.DELIVERED_AT" | translate }}</dt>
            <dd>{{ email.delivered_at | date: dateFormat }}</dd>
          </ng-container>
          <ng-container *ngIf="email.last_opened_at">
            <dt>{{ "SENT_EMAILS.DETAIL.LAST_OPENED_AT" | translate }}</dt>
            <dd>{{ email.last_opened_at | date: dateFormat }}</dd>
          </ng-container>
          <dt>{{ "SENT_EMAILS.DETAIL.FROM" | translate }}</dt>
          <dd>{{ fromLabel }}</dd>
          <dt>{{ "SENT_EMAILS.DETAIL.REPLY_TO" | translate }}</dt>
          <dd>
            <ng-container *ngIf="replyTo.length > 0; else noReplyTo">
              <div *ngFor="let address of replyTo">{{ address }}</div>
            </ng-container>
            <ng-template #noReplyTo>
              <span class="sed-muted">{{
                "SENT_EMAILS.DETAIL.REPLY_TO_NONE" | translate
              }}</span>
            </ng-template>
          </dd>
          <ng-container *ngIf="email.sender_name">
            <dt>{{ "SENT_EMAILS.DETAIL.SENT_BY" | translate }}</dt>
            <dd>{{ email.sender_name }}</dd>
          </ng-container>
        </dl>

        <div *ngIf="email.error" class="sed-alert" role="alert">
          <mat-icon class="s-20 mr-8">{{ getIcon("WARNING") }}</mat-icon>
          <div>
            <b>{{ "SENT_EMAILS.DETAIL.ERROR_LABEL" | translate }} :</b>
            {{ email.error }}
          </div>
        </div>
      </section>
      <!-- / HEAD -->

      <!-- RECIPIENTS -->
      <section class="sed-section">
        <div class="sed-section-title">
          {{ "SENT_EMAILS.DETAIL.RECIPIENTS" | translate }}
        </div>
        <div *ngIf="recipientGroups.length === 0" class="sed-muted">
          {{ "SENT_EMAILS.DETAIL.NO_RECIPIENTS" | translate }}
        </div>
        <div *ngFor="let group of recipientGroups" class="sed-group">
          <div class="sed-group-title">{{ group.labelKey | translate }}</div>
          <div
            *ngFor="let recipient of group.recipients"
            class="sed-recipient"
            [class.is-problem]="recipient.is_problem"
          >
            <div class="sed-recipient-line">
              <div class="sed-recipient-name">
                {{ recipientLabel(recipient) }}
              </div>
              <app-sent-email-status
                [status]="recipient.status"
                [label]="recipient.status_label"
                [problem]="recipient.is_problem"
              ></app-sent-email-status>
            </div>
            <div class="sed-recipient-meta sed-muted">
              <span *ngIf="recipient.delivered_at">
                {{ "SENT_EMAILS.DETAIL.DELIVERED_AT" | translate }}
                {{ recipient.delivered_at | date: dateFormat }}
              </span>
              <span class="sed-counter">
                <mat-icon class="s-16">{{ getIcon("VISIBLILITY") }}</mat-icon>
                {{ recipient.opens || 0 }}
              </span>
              <span *ngIf="recipient.last_opened_at">
                {{ "SENT_EMAILS.DETAIL.LAST_OPENED_AT" | translate }}
                {{ recipient.last_opened_at | date: dateFormat }}
              </span>
            </div>
            <div *ngIf="recipient.last_error" class="sed-reason">
              <b>{{ "SENT_EMAILS.DETAIL.REASON" | translate }} :</b>
              {{ recipient.last_error }}
            </div>
          </div>
        </div>
      </section>
      <!-- / RECIPIENTS -->

      <!-- ATTACHMENTS -->
      <section class="sed-section">
        <div class="sed-section-title">
          {{ "SENT_EMAILS.DETAIL.ATTACHMENTS" | translate }}
        </div>
        <div *ngIf="!email.attachments?.length" class="sed-muted">
          {{ "SENT_EMAILS.DETAIL.NO_ATTACHMENTS" | translate }}
        </div>
        <div
          *ngFor="let attachment of email.attachments"
          class="sed-attachment"
        >
          <div class="sed-attachment-line">
            <mat-icon class="s-20 mr-8 sed-muted">{{
              getIcon("ATTACHMENT")
            }}</mat-icon>
            <div class="sed-attachment-name">
              <div>{{ attachment.filename }}</div>
              <div class="sed-muted">
                {{ attachmentKindKey(attachment) | translate }}
                <ng-container *ngIf="fileSize(attachment)">
                  · {{ fileSize(attachment) }}</ng-container
                >
              </div>
            </div>
            <!-- The wrapper carries the tooltip: a disabled button emits no mouse event. -->
            <span
              [matTooltip]="
                (attachment.is_downloadable
                  ? 'SENT_EMAILS.DETAIL.DOWNLOAD_LINK_INFO'
                  : notKeptKey(attachment)
                ) | translate
              "
              matTooltipPosition="left"
            >
              <button
                mat-stroked-button
                type="button"
                color="accent"
                [disabled]="
                  !attachment.is_downloadable || !!downloadingAttachmentUuid
                "
                (click)="onDownload(attachment)"
              >
                <mat-icon class="s-18 mr-4">{{
                  getIcon("FILE_DOWNLOAD")
                }}</mat-icon>
                {{ "SENT_EMAILS.DETAIL.DOWNLOAD" | translate }}
              </button>
            </span>
          </div>
          <div *ngIf="!attachment.is_downloadable" class="sed-attachment-note">
            {{ notKeptKey(attachment) | translate }}
          </div>
        </div>
      </section>
      <!-- / ATTACHMENTS -->

      <!-- DETAIL STILL LOADING (summary already shown) -->
      <div *ngIf="loading" class="sed-state">
        <mat-spinner [diameter]="32"></mat-spinner>
        <div class="sed-state-text mt-8">
          {{ "SENT_EMAILS.DETAIL.LOADING" | translate }}
        </div>
      </div>

      <ng-container *ngIf="detail">
        <!-- TIMELINE -->
        <section class="sed-section">
          <div class="sed-section-title">
            {{ "SENT_EMAILS.DETAIL.TIMELINE" | translate }}
          </div>
          <div *ngIf="events.length === 0" class="sed-muted">
            {{ "SENT_EMAILS.DETAIL.NO_EVENTS" | translate }}
          </div>
          <ol *ngIf="events.length > 0" class="sed-timeline">
            <li
              *ngFor="let event of events"
              class="sed-timeline-item"
              [class.is-problem]="isProblemEvent(event)"
              [class.is-success]="isSuccessEvent(event)"
            >
              <div class="sed-timeline-line">
                <span class="sed-timeline-label">{{ event.event_label }}</span>
                <span class="sed-muted">{{
                  event.occurred_at | date: dateFormat
                }}</span>
              </div>
              <div *ngIf="event.recipient" class="sed-muted">
                {{ event.recipient }}
              </div>
              <div *ngIf="event.reason" class="sed-reason">
                <b>{{ "SENT_EMAILS.DETAIL.REASON" | translate }} :</b>
                {{ event.reason }}
                <span *ngIf="event.delivery_code">
                  ({{ "SENT_EMAILS.DETAIL.DELIVERY_CODE" | translate }}
                  {{ event.delivery_code }})
                </span>
              </div>
              <div *ngIf="event.url" class="sed-muted sed-timeline-url">
                {{ "SENT_EMAILS.DETAIL.LINK" | translate }} : {{ event.url }}
              </div>
            </li>
          </ol>
        </section>
        <!-- / TIMELINE -->

        <!-- CONTENT -->
        <section class="sed-section">
          <div class="sed-section-title">
            {{ "SENT_EMAILS.DETAIL.CONTENT" | translate }}
          </div>

          <div *ngIf="!detail.has_content" class="sed-notice">
            <mat-icon class="s-20 mr-8">{{ getIcon("INFO") }}</mat-icon>
            <div>{{ "SENT_EMAILS.DETAIL.CONTENT_NOT_KEPT" | translate }}</div>
          </div>

          <!-- Isolated frame: no script, opaque origin, content through srcdoc. -->
          <iframe
            *ngIf="frameDocument"
            class="sed-frame"
            sandbox="allow-popups allow-popups-to-escape-sandbox"
            referrerpolicy="no-referrer"
            [title]="'SENT_EMAILS.DETAIL.CONTENT_FRAME_TITLE' | translate"
            [srcdoc]="frameDocument"
          ></iframe>

          <ng-container *ngIf="!frameDocument && textBody">
            <div class="sed-muted mb-8">
              {{ "SENT_EMAILS.DETAIL.CONTENT_TEXT_ONLY" | translate }}
            </div>
            <pre class="sed-text">{{ textBody }}</pre>
          </ng-container>

          <div
            *ngIf="detail.has_content && !frameDocument && !textBody"
            class="sed-notice"
          >
            <mat-icon class="s-20 mr-8">{{ getIcon("INFO") }}</mat-icon>
            <div>{{ "SENT_EMAILS.DETAIL.CONTENT_EMPTY" | translate }}</div>
          </div>
        </section>
        <!-- / CONTENT -->
      </ng-container>
    </ng-container>
  </div>

  <footer class="panel-footer gt2-buttons-theme flex-row-center-center">
    <button
      mat-raised-button
      type="button"
      color="primary"
      class="mr-8 ml-8 mt-4 mb-4"
      (click)="close()"
    >
      {{ "SENT_EMAILS.CLOSE" | translate }}
    </button>
  </footer>
</div>
